import React, { useContext, useEffect } from 'react'
import styled, { keyframes } from 'styled-components'
import CaptionInput from '../../../caption-input'
import { CreationSourceEditorContext } from '../../manager'
import { SourceEditorCaption } from '../../types'

const fadeIn = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`

const Input = styled(CaptionInput)`
    animation: ${fadeIn} 0.2s ease-out;
    margin-bottom: 30px;
`

type Props = {
    caption: SourceEditorCaption
    active?: boolean
    index: number
    onAdd: () => void
    onRemove: () => void
    onFocus: () => void
}

const CreationSourceEditorCaptionInput = ({ caption, active = false, index, onAdd, onFocus, onRemove }: Props) => {
    const { captions, setCaptions, captionStyle, setCaptionStyle } = useContext(CreationSourceEditorContext)

    useEffect(() => {
        // update caption styles
        if (active) {
            setCaptions(
                captions.map((c, i) => {
                    if (i === index) {
                        return { ...c, style: captionStyle }
                    }
                    return c
                })
            )
        }
    }, [captionStyle])

    useEffect(() => {
        if (active) {
            setCaptionStyle(caption.style)
        }
    }, [active])

    const onInput = (value: string) => {
        setCaptions(
            captions.map((c, i) => {
                if (i === index) {
                    return { ...c, text: value }
                }
                return c
            })
        )
    }

    return (
        <Input
            {...{
                defaultValue: caption.text,
                onAdd,
                onFocus,
                onInput,
                onRemove,
            }}
        />
    )
}

export default CreationSourceEditorCaptionInput
